export default __webpack_public_path__ + "static/media/flow_start.713d6d08.svg";